import React from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const Label = styled.label`
  color: var(--color-mainDark);
  font-size: 0.82rem;
  font-weight: 800;
`;

const StyledInput = styled.input`
  width: 100%;
  min-height: 3.2rem;
  padding: 0.78rem 0.95rem;
  border: 1px solid ${({ $invalid }) => ($invalid ? 'var(--color-errorRed)' : 'var(--color-borderStrong)')};
  border-radius: 0.9rem;
  color: var(--color-text);
  background: #fff;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;

  &::placeholder {
    color: #92908b;
  }

  &:hover {
    border-color: #aaa49a;
  }

  &:focus {
    border-color: #000;
    box-shadow: 0 0 0 4px rgba(192, 163, 117, 0.2);
    outline: none;
  }

  &:disabled,
  &[readonly] {
    color: #706d68;
    background: #f3f1ed;
    cursor: not-allowed;
  }
`;

const Error = styled.span`
  min-height: 1.05rem;
  color: var(--color-errorRed);
  font-size: 0.76rem;
  font-weight: 700;
`;

const Input = ({ field, form: { touched, errors }, label, ...props }) => {
  const hasError = Boolean(errors[field.name] && touched[field.name]);
  const errorId = `${field.name}-error`;

  return (
    <InputWrapper>
      {label ? <Label htmlFor={field.name}>{label}</Label> : null}
      <StyledInput
        id={field.name}
        {...field}
        {...props}
        $invalid={hasError}
        aria-invalid={hasError}
        aria-describedby={hasError ? errorId : undefined}
      />
      <Error id={errorId} role={hasError ? 'alert' : undefined}>
        {hasError ? errors[field.name] : ''}
      </Error>
    </InputWrapper>
  );
};

export default Input;
